import Profile from 'components/global/Profile';

export default Profile;
